import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { finalize } from 'rxjs';
import { UserService } from 'src/app/dataServices/userService';
import { QuoteByUserId } from '../../models/quotes';
import { User } from 'src/app/models/user';
import { AppState } from 'src/app/services/app.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ConfigService } from 'src/app/services/configService';

@Component({
    selector: 'self-ins-policies-and-request-page',
    templateUrl: './policies-and-request-page.html',
    styleUrls: ['./policies-and-request-page.scss']
})
export class PoliciesAndRequestsPageComponent implements OnInit {
    @Output() onChangeQuote = new EventEmitter<QuoteByUserId>();
    public user: User = this.appState.user.getValue();
    public quotes: QuoteByUserId[] = [];
    public selectedQuote: QuoteByUserId = {} as QuoteByUserId;
    public qnum = 0;
    public qsuffix = '';
    public wcPortalUrl = '';

    public get wcCompQuoteUrl() {
        let params = [
            (this.user?.verificationInfo?.userName ? `applicantName=${this.user.verificationInfo.userName}` : ''),
            (this.user?.verificationInfo?.insuredName ? `insuredName=${this.user.verificationInfo.insuredName}` : ''),
            (this.user?.verificationInfo?.insuredAddress ? `insuredAddress=${this.user.verificationInfo.insuredAddress}` : ''),
            (this.user?.verificationInfo?.insuredCity ? `insuredCity=${this.user.verificationInfo.insuredCity}` : ''),
            (this.user?.verificationInfo?.insuredState ? `insuredState=${this.user.verificationInfo.insuredState}` : ''),
            (this.user?.verificationInfo?.insuredZip ? `insuredZip=${this.user.verificationInfo.insuredZip}` : ''),
            (this.user?.verificationInfo?.userPhone ? `phone=${this.user.verificationInfo.userPhone}` : '')
        ].filter(x => x).join('&');

        return `${this.wcPortalUrl}/?${params}`;
    }
    
    public constructor(private activeRouter: ActivatedRoute,
        private progressBar: NgProgress,
        private userService: UserService,
        private appState: AppState,
        private _datepipe: DatePipe,
        private config: ConfigService,
        private router: Router
        ) {
            this.wcPortalUrl = `${this.config.get('wcPortalUrl')}`;
        }

    public ngOnInit() {
        this.activeRouter.queryParams.subscribe(params => {
            this.qnum = params['qnum'];
            this.qsuffix = params['qsuffix'];

            this.userService.getQuotes()
            .pipe(
                finalize(() => this.progressBar.ref().complete())
            )
            .subscribe((quotes) => {
                    if (quotes) {
                        this.quotes = quotes;
                        if (this.qnum && this.qsuffix) {
                            this.selectedQuote = quotes.find(x => x.qnum === Number(this.qnum) 
                                                    && x.qsuffix === this.qsuffix) || {} as QuoteByUserId;
                        } else {
                            this.selectedQuote = quotes[0];
                            this.router.navigate(['/coverage'], {
                                queryParams: {
                                    qnum: this.selectedQuote.qnum,
                                    qsuffix: this.selectedQuote.qsuffix
                                }
                            });
                        }
                        this.onChangeQuote.emit(this.selectedQuote);
                    }
                });
        });
    }

    public activeQuote(index: number) {
        if (this.quotes &&
            this.quotes[index] &&
            this.selectedQuote.qnum == this.quotes[index].qnum &&
            this.selectedQuote.qsuffix == this.quotes[index].qsuffix) {
                return true;
        }
        return false;
    }

    public selectQuote(index: number) {
        if (this.quotes && this.quotes[index]) {
            this.router.navigate(['/coverage'], {
                queryParams: {
                    qnum: this.quotes[index].qnum,
                    qsuffix: this.quotes[index].qsuffix
                }
            });
        }
    }

    public getQuoteName(quote: QuoteByUserId) {
        const effdate = this._datepipe.transform(quote.effDate, 'MM/dd/yyyy');
        const expDate = this._datepipe.transform(quote.expDate, 'MM/dd/yyyy');

        if (quote.masterPolicyNumber) {
            return `${quote.linebusName} ${quote.masterPolicyNumber} ${effdate}-${expDate}`;
        } else {
            return `${quote.linebusName} ${quote.policyNumber} ${effdate}-${expDate}`;
        }
    }
}
